import { useCallback, useEffect, useState } from "react";

type Bloc = { type: string; contenu: string };

/**
 * Téléprompteur d'appel. L'étape 3 impose le silence : c'est la seule
 * consigne du speech qu'un commercial n'applique jamais, donc la seule
 * que l'interface rend physique.
 */
export function Prompteur({ blocs, onFermer }: { prospectId: string; blocs: Bloc[]; onFermer: () => void }) {
  const [etape, setEtape] = useState(0);
  const [secondes, setSecondes] = useState(0);

  const contenu = useCallback((type: string) => blocs.find(b => b.type === type)?.contenu ?? "", [blocs]);

  useEffect(() => {
    if (etape !== 2) return;
    const t = setInterval(() => setSecondes(s => s + 1), 1000);
    return () => clearInterval(t);
  }, [etape]);

  useEffect(() => {
    const k = (e: KeyboardEvent) => {
      if (e.key === "Escape") onFermer();
      if (e.key === " ") { e.preventDefault(); setEtape(n => Math.min(n + 1, 3)); }
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onFermer]);

  const etapes = [
    { texte: contenu("accroche"), indice: "Lire posément. Ne pas accélérer.", suivant: "Poser la question" },
    { texte: contenu("question_ouverte"), indice: "Poser la question, puis appuyer sur espace.", suivant: "Se taire" },
    { texte: "SE TAIRE", indice: `Sa réponse est le vrai début de l'entretien. Silence : ${secondes} s`, suivant: "Il a répondu" },
    { texte: contenu("suite"), indice: "Enchaîner, puis proposer deux créneaux.", suivant: "Terminer" }
  ];
  const e = etapes[etape]!;

  return (
    <div className="prompteur" role="dialog" aria-modal="true" aria-label="Téléprompteur d'appel">
      <div className="stage">
        <p className={etape === 2 ? "silence" : "ligne"}>{e.texte}</p>
        <p className="indice">{e.indice}</p>
      </div>
      <div className="foot">
        <button className="btn" onClick={() => (etape >= 3 ? onFermer() : setEtape(etape + 1))}>{e.suivant}</button>
        <button className="btn ghost clair" onClick={onFermer}>Fermer</button>
      </div>
    </div>
  );
}
